import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Suppress the benign "ResizeObserver loop" warning some third-party widgets
// (e.g. Elfsight review carousels) emit — it is not a real error and would
// otherwise trigger the dev-only error overlay. (No effect in production.)
const RO_ERR = /ResizeObserver loop (limit exceeded|completed with undelivered notifications)/;
const hideOverlay = () => {
  // react-error-overlay appends a srcless full-screen iframe directly to <body>
  document.querySelectorAll("body > iframe:not([src])").forEach((f) => {
    f.style.display = "none";
  });
  const wds = document.getElementById("webpack-dev-server-client-overlay");
  if (wds) wds.remove();
};
window.addEventListener(
  "error",
  (e) => {
    if (e.message && RO_ERR.test(e.message)) {
      e.stopImmediatePropagation();
      e.preventDefault();
      setTimeout(hideOverlay, 0);
    }
  },
  true,
);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
